import {
  NumericFormatType,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TopInstitutionsHoldersTotalPeerOwnershipModel } from './top-institutions-holders-total-peer-ownership.model';

export class TopInstitutionsHoldersTotalPeerOwnershipConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TopInstitutionsHoldersTotalPeerOwnershipConfiguration';
  nodataLocalizationKeyName = 'topInstitutionsHoldersTotalPeerOwnership';
  readonly reportSection = ReportSection.TopInstitutionsHoldersTotalPeerOwnership;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [
    ReportViewModelSection.OwnershipAnalyticsReport_TopInstitutionsHoldersTotalPeerOwnership
  ];
  override disableSectionReordering = true;
  readonly minSize = 4;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipInstitutionName',
      displayName: 'Institution',
      isSelected: true,
      isStatic: true,
      canConfigure: false,
      unit: 2,
      property: 'institutionName',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipMySecurityValueMm',
      displayName: 'My Security Value',
      isSelected: true,
      isStatic: true,
      canConfigure: false,
      unit: 2,
      property: 'mySecurityValueMm',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.InMillions
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipMySecurityValueChangeMm',
      displayName: 'My Security Value Change',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 2,
      property: 'mySecurityValueChangeMm',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.InMillions
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipPeerTotalValueMm',
      displayName: 'Peer Total Value',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 1,
      property: 'peerTotalValueMm',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.InMillions
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipPeerTotalValueChangeMm',
      displayName: 'Peer Total Value Change',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 1,
      property: 'peerTotalValueChangeMm',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.InMillions
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipPeerHeld',
      displayName: '# Peer Held',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 2,
      property: 'peerHeld',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipPeersHeld',
      displayName: 'Peers Held',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 2,
      property: 'peersHeld',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipStyle',
      displayName: 'Style',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 1,
      property: 'style',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'topInstitutionsHoldersTotalPeerOwnershipTurnover',
      displayName: 'Turnover',
      isSelected: true,
      isStatic: false,
      canConfigure: true,
      unit: 1,
      property: 'turnover',
      type: ReportSectionConfigurationControlType.Text
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'topInstitutionsHoldersTotalPeerOwnership';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Top 20 Institutional Holders vs Total Peer Ownership';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TopInstitutionsHoldersTotalPeerOwnershipData {
  [ReportViewModelSection.OwnershipAnalyticsReport_TopInstitutionsHoldersTotalPeerOwnership]: TopInstitutionsHoldersTotalPeerOwnershipModel;
}
